export const OPEN_GIFT_CARD_MODAL = 'open_gift_card_modal';
export const CLOSE_GIFT_CARD_MODAL = 'close_gift_card_modal';
export const GET_GIFT_CARD = "get_gift_card";
export const UPDATE_GIFT_CARD = "update_gift_card";
export const DELETE_GIFT_CARD = "delete_gift_card";
export const MARK_GIFT_CARD_AS_PRINTED = "mark_gift_card_as_printed";
export const GENERATE_GIFT_CARDS = "generate_gift_cards";